<button *ngIf="!callUrl" class="btn btn-outline-primary" (click)="play()">{{ 'hx.call-audio.play' | transloco }}</button>

<audio preload="none" autoplay controls *ngIf="callUrl">
  <source [src]="callUrl">
</audio>
